
import Vue from 'vue'
import { Prop, Component } from 'vue-property-decorator'
import { Chart, ChartConfiguration, ChartTypeRegistry } from 'chart.js'

@Component
export default class AppChart<T extends keyof ChartTypeRegistry, D> extends Vue {
  @Prop({ type: String })
  private readonly maxWidth!: string

  @Prop({ type: String })
  private readonly maxHeight!: string

  private initialised = false

  private loading = true

  private chart?: Chart<T, D[], string>

  get canvas() {
    return this.$refs.canvas as HTMLCanvasElement
  }

  get style() {
    const styles = ['width: 100%']

    if (this.maxWidth) {
      styles.push(`max-width: ${this.maxWidth}`)
    }

    if (this.maxHeight) {
      styles.push(`max-height: ${this.maxHeight}`)
    }

    return styles.join(';')
  }

  private initChart (config: ChartConfiguration<T, D[], string>) {
    if (this.canvas) {
      this.chart = new Chart(this.canvas, config)
      this.initialised = true
    }
    this.loading = false
  }

  private replaceChartData(config: ChartConfiguration<T, D[], string>) {
    if (!this.chart) {
      return
    }

    this.chart.data.labels?.splice(0, this.chart.data.labels?.length || 0)
    const originalColors = this.chart.data.datasets.map(set => set.backgroundColor)
    this.chart.data.datasets.splice(0, this.chart.data.datasets.length)

    if (config.data.labels) {
      config.data.labels.forEach(label => this.chart?.data.labels?.push(label))
    }

    config.data.datasets.forEach((set, index) => {
      set.backgroundColor = originalColors[index] || set.backgroundColor
      this.chart?.data.datasets.push(set)
    })
    this.chart.update()
  }

  public loadConfig(config: ChartConfiguration<T, D[], string>) {
    if (this.chart) {
      const chartConfig = this.chart.config as ChartConfiguration<T, D[], string>
      if (chartConfig.type !== config.type) {
        this.chart.destroy()
        this.initChart(config)
      } else {
        this.replaceChartData(config)
      }
    } else {
      this.initChart(config)
    }
  }
}
